import { useState, useEffect } from "react";
import { supa } from "./firebase";
import { Trash } from 'iconoir-react'
import ActivityIndicator from "./activityIndicator";

function ModalInfoPacchetto({ setVisible, aggiorna, utente, pacchetto }) {
    const [notes, setNotes] = useState('');
    const [inizio, setInizio] = useState(new Date());
    const [fine, setFine] = useState(new Date());
    const [acconto, setAcconto] = useState(0);
    const [totale, setTotale] = useState(0);
    const [versamenti, setVersamenti] = useState([]);
    const [lezioniEffettuate, setLezioniEffettuate] = useState([]);
    const [loading, setLoading] = useState(false);  // Indica il caricamento generale
    const [isLoading, setIsLoading] = useState(false);  // Loading individuale per ciascuna funzione



    async function patchRow() {
        setIsLoading(true);
        const { error } = await supa
            .from('pacchettiAcquistati')
            .update({
                "inizio": inizio,
                "fine": fine,
                "acconto": parseInt(acconto) + parseInt(pacchetto.acconto),
                "note": notes,
                "totale": parseInt(totale)
            })
            .eq('id', pacchetto.id);

        if (error) {
            console.log(error);
            setIsLoading(false);
            return;
        }

        if (parseInt(acconto) > 0) {
            const { error: error2 } = await supa
                .from('versamenti')
                .insert({
                    "id_utente": utente.id,
                    "id_pacchettiAcquistati": pacchetto.id,
                    "importo": parseInt(acconto),
                    "data": new Date().toISOString().split('T')[0]
                });
            
            if (error2) console.log(error2);
        }

        aggiorna();
        setVisible(false);
        setIsLoading(false);
    }

    async function getVersamenti() {
        setIsLoading(true);
        const { data, error } = await supa
            .from('versamenti')
            .select('*')
            .eq('id_pacchettiAcquistati', pacchetto.id);

        if (error) {
            console.log(error);
            setIsLoading(false);
            return;
        }

        data.sort((a, b) => new Date(a.data) - new Date(b.data));
        setVersamenti(data);
        setIsLoading(false);
    }

    async function deleteVersamento(versamento) {
        setIsLoading(true);
        const { error } = await supa
            .from('versamenti')
            .delete()
            .eq('id', versamento.id);

        if (error) {
            console.log(error);
            setIsLoading(false);
            return;
        }

        const { error: error2 } = await supa
            .from('pacchettiAcquistati')
            .update({ "acconto": pacchetto.acconto - versamento.importo })
            .eq('id', pacchetto.id);

        if (error2) console.log(error2);

        aggiorna();
        getVersamenti();
        setIsLoading(false);
    }

    async function getLezioniEffettuate() {
        setIsLoading(true);
        const { data, error } = await supa
            .from('lezioni')
            .select('*, personalTrainer(*)')
            .eq('id_pacchetto_personal', pacchetto.id);

        if (error) {
            console.log(error);
            setIsLoading(false);
            return;
        }

        data.sort((a, b) => new Date(a.data) - new Date(b.data));
        setLezioniEffettuate(data);
        setIsLoading(false);
    }

    const deleteRow = async () => {
        setIsLoading(true);
        const { error } = await supa
            .from('pacchettiAcquistati')
            .delete()
            .eq('id', pacchetto.id);

        if (error) {
            console.log(error);
            setIsLoading(false);
            return;
        }

        aggiorna();
        setVisible(false);
        setIsLoading(false);
    };

    const deleteLezione = async (id) => {
        setIsLoading(true);
        const { error } = await supa
            .from('lezioni')
            .delete()
            .eq('id', id);

        if (error) {
            console.log(error);
            setIsLoading(false);
            return;
        }

        const { error: error2 } = await supa
            .from('pacchettiAcquistati')
            .update({ "sedute_effettuate": pacchetto.sedute_effettuate - 1 })
            .eq('id', pacchetto.id);

        if (error2) console.log(error2);

        aggiorna();
        getLezioniEffettuate();
        setIsLoading(false);
    };

    const alertDelete = () => {
        if (window.confirm('Sei sicuro di voler eliminare questo pacchetto?')) {
            deleteRow();
        }
    };

    const alertDeleteVersamento = (versamento) => {
        if (window.confirm(`Sei sicuro di voler eliminare il versamento di ${versamento.importo} € del ${new Date(versamento.data).toLocaleDateString('it-IT')}?`)) {
            deleteVersamento(versamento);
        }
    };

    const alertModifica = () => {
        if (window.confirm('Sei sicuro di voler salvare le modifiche?')) {
            patchRow();
        }
    };

    const alertDeleteLezione = (lezione) => {
        if (window.confirm(`Sei sicuro di voler eliminare la lezione del ${new Date(lezione.data).toLocaleDateString('it-IT')} con ${lezione.personalTrainer.nome} ${lezione.personalTrainer.cognome}?`)) {
            deleteLezione(lezione.id);
        }
    };

    useEffect(() => {
        getLezioniEffettuate();
        setInizio(pacchetto.inizio);
        setFine(pacchetto.fine);
        setNotes(pacchetto.note);
        setTotale(pacchetto.totale);
        getVersamenti();
    }, []);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm overflow-y-auto">
            {isLoading && <ActivityIndicator />}
            <div className="relative w-full max-w-4xl mx-4 my-8 animate-in fade-in zoom-in duration-200">
                <div className="relative bg-white rounded-2xl shadow-2xl border border-zinc-200 max-h-[90vh] overflow-hidden flex flex-col">
                    {/* Header */}
                    <div className="flex items-center justify-between p-6 border-b border-zinc-200">
                        <div>
                            <h3 className="text-2xl font-bold text-zinc-900">Info Pacchetto</h3>
                            <p className="text-sm text-zinc-600 mt-1">Modifica le informazioni del pacchetto</p>
                        </div>
                        <button 
                            onClick={() => setVisible(false)} 
                            className="p-2 text-zinc-400 hover:text-zinc-600 hover:bg-zinc-100 rounded-lg transition-all"
                        >
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Body - Scrollable */}
                    <form className="p-6 overflow-y-auto flex-1">
                        <div className="grid gap-6 mb-6 md:grid-cols-2">
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Utente</label>
                                <div className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm text-zinc-900 font-medium">
                                    {utente.nome} {utente.cognome}
                                </div>
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Pacchetto</label>
                                <div className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm text-zinc-900 font-medium">
                                    {pacchetto?.pacchetti?.nome}
                                </div>
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Data Inizio</label>
                                <input 
                                    type="date" 
                                    value={inizio} 
                                    onChange={(e) => setInizio(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Data Fine</label>
                                <input 
                                    type="date" 
                                    value={fine} 
                                    onChange={(e) => setFine(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Totale (€)</label>
                                <input 
                                    type="number" 
                                    onChange={(e) => setTotale(e.target.value)} 
                                    value={totale} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="0.00"
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Acconto Attuale</label>
                                <div className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm text-zinc-900 font-medium">
                                    {pacchetto?.acconto} €
                                </div>
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Rimanente</label>
                                <div className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm text-zinc-900 font-semibold">
                                    {pacchetto?.totale - pacchetto?.acconto - acconto} €
                                </div>
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Nuovo Acconto (€)</label>
                                <input 
                                    type="number" 
                                    onChange={(e) => setAcconto(e.target.value)} 
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all" 
                                    placeholder="0.00"
                                />
                            </div>
                            <div className="md:col-span-2">
                                <label className="block mb-2 text-sm font-semibold text-zinc-700">Eventuali Note</label>
                                <textarea 
                                    value={notes} 
                                    onChange={(e) => setNotes(e.target.value)} 
                                    rows="3"
                                    className="w-full px-4 py-2.5 bg-zinc-50 border border-zinc-300 rounded-xl text-sm focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition-all resize-none" 
                                    placeholder="Inserisci note..."
                                ></textarea>
                            </div>

                            {/* Lezioni effettuate */}
                            <div className="md:col-span-2 mt-4">
                                <div className="flex justify-between items-center mb-3">
                                    <label className="text-sm font-semibold text-zinc-700">Lezioni Effettuate</label>
                                    <span className="text-sm font-semibold text-zinc-900 bg-zinc-100 px-3 py-1 rounded-lg">{lezioniEffettuate?.length}</span>
                                </div>
                                <div className="bg-zinc-50 border border-zinc-200 rounded-xl overflow-hidden h-48">
                                    <div className="overflow-y-auto h-full noBar">
                                        <table className="w-full text-left text-sm">
                                            <thead className="bg-zinc-100 sticky top-0 z-10 border-b border-zinc-200">
                                                <tr>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">#</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Data</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Personal Trainer</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Azioni</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lezioniEffettuate?.map((item, index) => (
                                                    <tr key={index} className="border-b border-zinc-200 hover:bg-zinc-50/50">
                                                        <td className="px-4 py-3 text-zinc-600">{index + 1}</td>
                                                        <td className="px-4 py-3 text-zinc-900">{item?.data ? new Date(item?.data).toLocaleDateString('it-IT') : ""}</td>
                                                        <td className="px-4 py-3 text-zinc-900">{item?.personalTrainer?.nome} {item?.personalTrainer?.cognome}</td>
                                                        <td className="px-4 py-3">
                                                            <Trash onClick={() => alertDeleteLezione(item)} className='cursor-pointer text-red-500 hover:text-red-700 transition-colors' size={20} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* Versamenti */}
                            <div className="md:col-span-2 mt-4">
                                <div className="flex justify-between items-center mb-3">
                                    <label className="text-sm font-semibold text-zinc-700">Versamenti Effettuati</label>
                                    <span className="text-sm font-semibold text-zinc-900 bg-zinc-100 px-3 py-1 rounded-lg">{versamenti?.length}</span>
                                </div>
                                <div className="bg-zinc-50 border border-zinc-200 rounded-xl overflow-hidden h-48">
                                    <div className="overflow-y-auto h-full noBar">
                                        <table className="w-full text-left text-sm">
                                            <thead className="bg-zinc-100 sticky top-0 z-10 border-b border-zinc-200">
                                                <tr>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">#</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Data</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Importo</th>
                                                    <th className="px-4 py-3 font-semibold text-zinc-700">Azioni</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {versamenti?.map((item, index) => (
                                                    <tr key={index} className="border-b border-zinc-200 hover:bg-zinc-50/50">
                                                        <td className="px-4 py-3 text-zinc-600">{index + 1}</td>
                                                        <td className="px-4 py-3 text-zinc-900">{item?.data ? new Date(item?.data).toLocaleDateString('it-IT') : ""}</td>
                                                        <td className="px-4 py-3 text-zinc-900 font-semibold">{item?.importo} €</td>
                                                        <td className="px-4 py-3">
                                                            <Trash onClick={() => alertDeleteVersamento(item)} className='cursor-pointer text-red-500 hover:text-red-700 transition-colors' size={20} />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    {/* Footer - Fixed */}
                    <div className="flex items-center justify-between gap-3 p-6 border-t border-zinc-200">
                        <button 
                            type="button"
                            onClick={() => alertModifica()}
                            className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-zinc-900 bg-yellow-400 hover:bg-yellow-500 rounded-xl shadow-sm hover:shadow transition-all"
                        >
                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            Salva Modifiche
                        </button>
                        <button 
                            type="button"
                            onClick={() => alertDelete()}
                            className="px-5 py-2.5 text-sm font-semibold text-white bg-red-500 hover:bg-red-600 rounded-xl transition-all"
                        >
                            Elimina Pacchetto
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalInfoPacchetto;
